import { i18n } from '@/i18n'

let loading: Promise<void> | null = null

async function loadAndMerge(): Promise<void> {
  // Both the loader and the catalogs behind it are separate chunks (ADR-010 D4a).
  const { loadAdminMessages } = await import('@admin/i18n/loadAdminMessages')
  const catalogs = await loadAdminMessages()
  // Both languages: the account language can change while the Admin Panel is open.
  for (const [locale, messages] of Object.entries(catalogs)) {
    i18n.global.mergeLocaleMessage(locale, messages)
  }
}

/**
 * Merges the Admin Panel's `admin.*` catalogs into Kora Web's vue-i18n once. Memoised; a failed
 * load clears the memo and rethrows, so the router's error path treats it like any failed lazy
 * chunk and the next navigation retries.
 */
export function ensureAdminMessages(): Promise<void> {
  if (loading === null) {
    loading = loadAndMerge().catch((error: unknown) => {
      loading = null
      throw error
    })
  }
  return loading
}
